<template>
  <v-container>
    <div class="bounty-details" v-if="reward">
      <div class="image-container">
        <bounty-image-swiper :pictures="pictures" />
      </div>
      <div class="box">
        <div class="box-header">
          <h2 class="box-title">{{reward.name}}</h2>
        </div>
        <div class="box-body">
          <div v-if="reward.contest && !hideProgress" class="points">
            <span v-if="reward.is_participating">{{$t('bounties.youAreParticipating')}}</span>
            <span v-else-if="reward.point_contest && reward.needed_points == 0" class="caption">{{ $tc('bounties.neededPointsRequirementText',0,{points: 0}) }}</span>
            <span v-else-if="reward.point_contest"><strong>{{ $t('bounties.redeemBountyPointsText', {count: customerRelationshipPoints.toLocaleString()}) }}</strong> / {{reward.needed_points.toLocaleString()}}</span>
            <span v-else-if="reward.cr_rank && reward.show_ranking">{{ $t('bounties.contestDetailScreenRanking', { rank: reward.cr_rank }) }}</span>
          </div>

          <div v-if="!reward.contest && !hideProgress" class="points">
            <span v-if="reward.needed_points == 0" class="caption">{{ $tc('bounties.neededPointsRequirementText',0,{points: 0}) }}</span>
            <span v-else-if="reward.is_redeemable || reward.is_activateable">
              <strong>{{ $t('bounties.redeemBountyPointsText', {count: reward.needed_points.toLocaleString()}) }}</strong>/{{reward.needed_points.toLocaleString()}}
            </span>
            <span v-else><strong>{{ $t('bounties.redeemBountyPointsText', {count: customerRelationshipPoints.toLocaleString()}) }}</strong> / {{ reward.needed_points.toLocaleString() }}</span>
          </div>

          <div v-if="!hideProgress">
            <v-progress-linear
              v-if="reward.show_progress_bar && !reward.is_participating && !reward.show_ranking"
              :value="progress"
            />
          </div>

          <v-row v-if="reward.description">
            <v-col>
              <h3>{{$t('bounties.description')}}</h3>
              <div v-html="reward.description"></div>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col>
              <h3 class="body-2 font-italic">{{ $t('bounties.redeemBountyDetailsMissingDescription') }}</h3>
            </v-col>
          </v-row>

          <contest-details :bounty="reward" v-if="reward.contest"/>
          <in-shop-details :bounty="reward" v-else />

        </div>
      </div>
    </div>

  </v-container>
</template>

<script>
  import _ from 'lodash'
  import {mapGetters} from 'vuex'
  import ContestDetails from '@/components/bounty/ContestDetails';
  import InShopDetails from '@/components/bounty/InShopDetails';
  import BountyImageSwiper from '@/components/bounty/BountyImageSwiper';

  export default {
    name: "RewardsOverview",
    components: {
      ContestDetails,
      InShopDetails,
      BountyImageSwiper,
    },
    data() {
      return {
        id: undefined,
        loading: false
      }
    },
    created() {
      this.id = this.$route.params.id;
    },
    async mounted() {
      await this.$store.dispatch('getRewards', {once: true});
    },
    computed: {
      ...mapGetters(['getRewardById', 'client']),
      reward() {
        return this.getRewardById(this.id);
      },
      progress() {
        if (this.reward.needed_points === 0) {
          return 100;
        }
        return (this.customerRelationshipPoints < this.reward.needed_points) ? Math.ceil(this.customerRelationshipPoints * 100 / this.reward.needed_points) : 100;
      },
      hideProgress() {
        const neededPoints = _.get(this.reward, 'needed_points', 0)

        return neededPoints === 0 || _.isNull(neededPoints)
      },
      customerRelationshipPoints() {
        let crp = _.defaultTo(_.get(this.reward, 'cr_points'), 0);
        return (crp < this.reward.needed_points) ? crp : this.reward.needed_points;
      },
      pictures() {
        if (!_.isEmpty(this.reward.pictures)) {
          return this.reward.pictures.map((picture) => picture.image);
        }
        if (_.get(this.reward, 'image', null)) {
          return [this.reward.image];
        }
        return [];
      }
    }
  }
</script>

<style scoped lang="scss">
  .v-progress-linear {
    margin-bottom: 24px;
  }
  .box ::v-deep.requirements {
    margin-bottom: 45px;
  }
</style>
